import { Policy } from "@deathstar/types/northstar";
import { ArrowTurnDownRightIcon } from "@heroicons/react/24/outline";
import { abbreviateAmsCustomerName } from "../utilities/abbreviateAmsCustomerName";

export function PolicyInsuranceCompanies({ policy }: { policy: Policy }): JSX.Element {
    const writingCompanyName = policy.writingCompany?.name ? abbreviateAmsCustomerName(policy.writingCompany.name) : "TBD";
    const parentCompanyName = policy.parentCompany?.name ? abbreviateAmsCustomerName(policy.parentCompany.name) : "TBD";
    return (
        <div>
            {parentCompanyName !== writingCompanyName ? <span className="text-gray-400">{parentCompanyName}</span> : null}
            <div className="flex items-center gap-1">
                {parentCompanyName !== writingCompanyName ? <ArrowTurnDownRightIcon className="h-4 w-4 text-gray-400" /> : null}
                <span>{writingCompanyName}</span>
            </div>
        </div>
    );
}
